<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <h3 :class="$style.title">船舶公司</h3>
      <search-field v-model="keywords" class="ml-auto" placeholder="请输入船舶公司" />
    </div>
    <div :class="$style.body">
      <el-scrollbar :wrap-class="$style.scroller">
        <index-block title="热门推荐">
          <div :class="$style.checkboxGroup">
            <el-checkbox v-model="state.company_id" :class="$style.checkboxItem" v-for="item in brands.hot" :key="item.id" :label="item.id">
              <el-image :class="$style.brandIcon" fit="cover" lazy :src="item.logo" />
              <div :class="$style.brandName">
                {{item.name}}
              </div>
            </el-checkbox>
          </div>
        </index-block>
        <index-block v-for="(item, key) in list" :key="key" :title="key">
          <div :class="$style.checkboxGroup">
            <el-checkbox v-model="state.company_id" :class="$style.checkboxItem" v-for="brand in item" :key="brand.id" :label="brand.id">
              <el-image :class="$style.brandIcon" fit="cover" lazy :src="brand.logo" />
              <div :class="$style.brandName">
                {{brand.name}}
              </div>
            </el-checkbox>
          </div>
        </index-block>
      </el-scrollbar>
    </div>
    <div :class="$style.footer">
      <button class="text-dark transition-colors hover:text-primary" @click="onReset"> <i class="el-icon-refresh-right" /> <span>重置</span></button>
      <div class="ml-auto">
        <el-button size="medium" @click="$emit('close')">取消</el-button>
        <el-button size="medium" type="primary" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {
	computed,
	defineComponent,
	reactive,
	useStore,
	watch,
	ref,
	watchEffect
} from "@nuxtjs/composition-api";
import indexBlock from "./index-block.vue";
import SearchField from "./search-field";
import IndexCheckboxGroup from "./index-checkbox-group.vue";
// import * as JsSearch from "js-search";
import { groupBy, isEmpty } from "lodash";

import useJsSearch from './composables/useJsSearch.js'

export default defineComponent({
	name: "IndexFilterBrand",
	components: {
		indexBlock,
		SearchField,
		IndexCheckboxGroup
	},
	props: {
		defaultData: {
			type: Object,
			default: () => ({ company_id: [] })
		}
	},
	emits: ["confirm", "close"],
	setup(props, { emit }) {
		const state = reactive({
			company_id: []
		});

		watch(
			() => props.defaultData.company_id,
			(value = []) => {
				state.company_id = [...value];
			},
			{
				immediate: true
			}
		);

		const store = useStore();
		const keywords = ref("");
		const brands = computed(() => {
			return store.state.cruiseMap.filterData.company;
		});

		const {addIndex, search, setComments} = useJsSearch();

		addIndex('name');
		addIndex('en_name');
		
		watchEffect(() => {
			if (!isEmpty(brands.value.list)) {
				setComments(Object.values(brands.value.list).flat());
			}
		});

		const list = computed(() => {
			const results = search(keywords.value);
			return groupBy(results, "letter");
		});
		// jsSearch.add

		function onReset() {
			state.company_id = [];
		}

		function onConfirm() {
			emit("confirm", {
				...state
			});
		}

		return {
			state,
			brands,
			keywords,
			list,

			onReset,
			onConfirm
			// hotOptions: computed(() => brands.value.)
		};
	}
});
</script>
<style lang="scss" module>
.container {
  padding: 1.5rem;
}
.header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.title {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.body {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
  padding-top: 1rem;
}
.scroller {
  max-height: 23rem;
}
.footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  padding-top: 0.625rem;
}
.checkboxGroup {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.checkboxItem {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
  margin-left: 0px;
  margin-right: 0px;
  overflow: hidden;
  width: 50%;
}
.checkboxItem :global(.el-checkbox__label) {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  overflow: hidden;
}
.brandIcon {
  border-width: 1px;
  height: 1rem;
  width: 2.75rem;
}
.brandName {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0%;
  -webkit-flex: 1 1 0%;
  flex: 1 1 0%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  min-width: 0px;
  overflow: hidden;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-right: 1.75rem;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>